/**
* AI写作-敏感词
**/ 

<template>
    
    
  <div class="ai-sensitive">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item >敏感词设置</el-breadcrumb-item>
      <!-- <el-breadcrumb-item v-if="detailShow">详情</el-breadcrumb-item> -->
    </el-breadcrumb>
    <el-card class="box-card">
    <div>
        <el-tabs type="card" v-model="activeName">
            <el-tab-pane label="自定义" name="first">
                <el-form  :model="form1" :rules="rules" ref="ruleForm" label-width="140px" label-suffix=":">
                    <el-form-item label="自定义敏感词库" prop="word">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 10, maxRows: 20}"
                            placeholder=""
                            v-model="form1.word">
                        </el-input>
                        <span>最多500行，每行一个，用[回车]隔开</span>
                    </el-form-item>
                    <el-form-item  >
                        <el-button type="primary" @click="submitFun('ruleForm')">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="系统" name="second">
                <el-form  :model="form2" label-suffix=":" label-width="140px">
                    <el-form-item label="自定义敏感词库" prop="keywords">
                        <el-input :readonly="true"
                            type="textarea"
                            :autosize="{ minRows: 10, maxRows: 20}"
                            placeholder=""
                            v-model="form2.word">
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
    
</el-card>
    </div>
</template>

<script>
// 导入组件
import { getSensitiveWord, modifySensitiveWord, createSensitiveWord} from '@/api/basisMG' 

// 导出模块
export default {
  // 模块名字
  name: "sensitive",
  // 模块数据
  data() {
    //数据  
    return {
        activeName: 'first',
        form1:{
            id: null,
            word: ''
        },
        rules: {
            word: [ { required: true, message: '请输入敏感词', trigger: 'blur' } ],
        },
        form2:{
            word: ''
        },
        
    };
  },
  // 注册组件
  components: {
    
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    getData() {
        getSensitiveWord().then(res=>{
            console.log(res)
            if(res.code===0){
                if(res.data.formUser){
                    this.form1 = res.data.formUser
                }
                if(res.data.formSys){
                    this.form2 = res.data.formSys
                }
            }else{
                console.log(res.message)
            }
        })
    },
    submitFun() {
        if(!this.form1.id){
            createSensitiveWord(this.form1).then(res=>{
                if(res.code===0){
                    this.$message.success('设置成功')
                }else{
                    this.$message.error(res.message)
                }
            })
        }else{
            modifySensitiveWord(this.form1.id, {"word":this.form1.word}).then(res=>{
                if(res.code===0){
                    this.$message.success('设置成功')
                }else{
                    this.$message.error(res.message)
                }
            })
        }
    }
  },
  mounted() {
    this.getData()
  },
};
</script>
// scoped 样式只在本组件使用
<style scoped>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
</style>



// WEBPACK FOOTER //
// src/views/ai/writer/sensitive.vue